/**
 * Prev / next controls with range summary. Assumes 1-based page index.
 */
export function Pagination({
  page,
  totalPages,
  onPageChange,
  total,
  from,
  to,
}) {
  if (total === 0) return null;

  return (
    <div className="pagination" role="navigation" aria-label="Pagination">
      <span className="pagination-range">
        {from}–{to} of {total}
      </span>
      <div className="pagination-actions">
        <button
          type="button"
          className="btn btn-sm btn-ghost"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          Previous
        </button>
        <span className="pagination-page mono">
          Page {page} / {totalPages}
        </span>
        <button
          type="button"
          className="btn btn-sm btn-ghost"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          Next
        </button>
      </div>
    </div>
  );
}
